/**
 * Standardizes any scholar ID string to SID followed by a 10-digit numeric number.
 * Example: SID1785430890
 */
export function formatScholarId(id?: string | null): string {
  if (!id) return "—";
  if (id.startsWith("SID") && id.length === 13) {
    return id;
  }
  if (id.startsWith("SID")) {
    return id;
  }
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash << 5) - hash + id.charCodeAt(i);
    hash |= 0;
  }
  const positiveHash = Math.abs(hash).toString().padStart(10, "0").slice(0, 10);
  return `SID${positiveHash}`;
}
